import React, { useState } from "react"
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import DeleteIcon from "@mui/icons-material/Delete"
import EditIcon from "@mui/icons-material/Edit"
import { formatCardDate } from "utils/flightLogic"

function FlightActionsSheet({ flight, onClose, onEdit, onDelete }) {
  const [confirming, setConfirming] = useState(false)

  const handleClose = () => {
    setConfirming(false)
    onClose()
  }

  const handleConfirmDelete = () => {
    onDelete(flight)
    handleClose()
  }

  return (
    <>
      <Drawer
        anchor="bottom"
        open={Boolean(flight) && !confirming}
        onClose={handleClose}
        PaperProps={{
          sx: { borderTopLeftRadius: 16, borderTopRightRadius: 16, pb: 2 },
        }}
      >
        {flight && (
          <>
            <Typography sx={{ px: 3, pt: 2.5, pb: 1.5, fontWeight: 700 }}>
              {flight.airlineCode || flight.airline} {flight.flightNumber} ·{" "}
              {formatCardDate(flight.date)}
            </Typography>
            <Divider />
            <List>
              <ListItemButton
                onClick={() => onEdit(flight)}
                sx={{ minHeight: 56 }}
              >
                <ListItemIcon>
                  <EditIcon />
                </ListItemIcon>
                <ListItemText primary="Edit flight" />
              </ListItemButton>
              <ListItemButton
                onClick={() => setConfirming(true)}
                sx={{ minHeight: 56 }}
              >
                <ListItemIcon>
                  <DeleteIcon color="error" />
                </ListItemIcon>
                <ListItemText
                  primary="Delete flight"
                  primaryTypographyProps={{ color: "error" }}
                />
              </ListItemButton>
              <ListItemButton onClick={handleClose} sx={{ minHeight: 56 }}>
                <ListItemIcon>
                  <CloseIcon />
                </ListItemIcon>
                <ListItemText primary="Cancel" />
              </ListItemButton>
            </List>
          </>
        )}
      </Drawer>

      <Dialog open={confirming} onClose={handleClose}>
        <DialogTitle>Delete this flight?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {flight
              ? `${flight.who} — ${flight.airlineCode || flight.airline} ${
                  flight.flightNumber
                } on ${formatCardDate(flight.date)}. This can't be undone.`
              : ""}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleClose} sx={{ minHeight: 44 }}>
            Cancel
          </Button>
          <Button
            color="error"
            variant="contained"
            onClick={handleConfirmDelete}
            sx={{ minHeight: 44 }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default FlightActionsSheet
